/* Keep the Judge.me review list compact on product pages while retaining its filters and review form. */
(() => {
  const visibleReviews = 3;
  const labels = document.documentElement.lang.toLowerCase().startsWith('de')
    ? { more: 'Mehr anzeigen', less: 'Weniger anzeigen' }
    : { more: 'Show more', less: 'Show less' };

  function attach(widget) {
    if (widget.dataset.nailartsReviewsToggleReady === 'true') return;
    widget.dataset.nailartsReviewsToggleReady = 'true';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'nailarts-reviews-toggle';
    button.hidden = true;
    button.textContent = labels.more;
    (widget.closest('.shopify-block') || widget.parentElement).appendChild(button);

    let expanded = false;
    let queued = false;
    let observedGrid;
    let resizeObserver;

    function sync() {
      const body = widget.querySelector('.jm-review-widget__body');
      const grid = body?.querySelector('.jdgm-masonry-grid__container');
      const items = grid
        ? [...grid.children].filter((item) => item.classList.contains('jdgm-masonry-grid__masonry-item'))
        : [];

      if (!body || items.length <= visibleReviews) {
        widget.classList.remove('nailarts-reviews-collapsed');
        button.hidden = true;
        return;
      }

      if (!body.id) body.id = 'nailarts-product-reviews-body';
      button.setAttribute('aria-controls', body.id);

      const top = body.getBoundingClientRect().top;
      const bottom = Math.max(...items.slice(0, visibleReviews).map((item) => item.getBoundingClientRect().bottom));
      widget.style.setProperty('--nailarts-reviews-preview-height', Math.max(280, Math.ceil(bottom - top + 12)) + 'px');

      widget.classList.toggle('nailarts-reviews-collapsed', !expanded);
      button.hidden = false;
      button.textContent = expanded ? labels.less : labels.more;
      button.setAttribute('aria-expanded', String(expanded));

      if (grid !== observedGrid && 'ResizeObserver' in window) {
        if (resizeObserver) resizeObserver.disconnect();
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(grid);
        observedGrid = grid;
      }
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        sync();
      });
    }

    button.addEventListener('click', () => {
      expanded = !expanded;
      sync();
    });
    new MutationObserver(schedule).observe(widget, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }

  function init() {
    document.querySelectorAll('#judgeme_product_reviews').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  const bootstrap = new MutationObserver(() => {
    init();
    if (document.querySelector('#judgeme_product_reviews')) bootstrap.disconnect();
  });
  if (!document.querySelector('#judgeme_product_reviews')) {
    bootstrap.observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', init);
})();
